import { CarouselGalleryUI } from "./CarouselGalleryUI";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { useSocialProofMessages } from "@/components/Galleries/hooks/useSocialProofMessages";
import { isM2MRomanBlindOrCurtain } from "@/utils/product/isMadeToMeasure";
import { useRouter } from "next/router";
import { filterM2MImages } from "@/components/Galleries/utils/filterM2MImages";
import {
  standardComponent,
  useStandardProps,
} from "@/context/StandardPropsContext/StandardPropsContext";

export const CarouselGallery = standardComponent("CarouselGallery", () => {
  const { product, sizes } = useStandardProps();
  const router = useRouter();
  const { variant } = useVariant(product);
  const media = "media" in product ? product.media : null;
  const videos = media?.videos || [];
  const { socialProofMessagesProperties } = useSocialProofMessages();

  if (!variant) return null;

  let images = variant.images;
  if (isM2MRomanBlindOrCurtain(product)) {
    images = filterM2MImages(images, router.query);
  }

  return (
    <CarouselGalleryUI
      title={variant.title}
      images={images}
      videos={videos}
      sizes={sizes}
      hasSocialProofMessagesExperience={true}
      socialProofMessagesProperties={socialProofMessagesProperties}
      dataComponent="CarouselGallery"
    />
  );
});
